exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".height-120[data-v-aa10d0ea]{height:calc(80vh - 120px)}.height-80[data-v-aa10d0ea]{height:80vh}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Systems/SystemAlarmsDetailsModal.vue"],"names":[],"mappings":"AACA,6BACI,yBAA2B,CAC9B,AACD,4BACI,WAAa,CAChB","file":"SystemAlarmsDetailsModal.vue","sourcesContent":["\n.height-120[data-v-aa10d0ea] {\n    height: calc(80vh - 120px);\n}\n.height-80[data-v-aa10d0ea] {\n    height: 80vh;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-aa10d0ea","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/Systems/SystemAlarmsDetailsModal.vue
// module id = 1636
// module chunks = 3 4 5 6 8